import { Injectable } from '@angular/core';

@Injectable()
export class AlertService {
  activate: (
    message?: string,
    title?: string,
    okText?: string,
    cancelText?: string,
    image?: string,
    preview?: boolean,
    previewLogin?: boolean
  ) => Promise<boolean>;
}



// WEBPACK FOOTER //
// ./src/app/core/alert/alert.service.ts